import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography, Button, Divider, Form, Input } from 'antd';
import { ClockCircleOutlined, ArrowRightOutlined } from '@ant-design/icons';

import HeaderBack from '../../../../components/mobile/HeaderBack';

const { Search } = Input;
const { Title, Paragraph } = Typography;

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
}

const data = [
  {
    title: 'Post Title 01',
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    url: '/knowledge-bank/detail/read/detail'
  },
  {
    title: 'Post Title 02',
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    url: '/knowledge-bank/detail/read//detail'
  },
  {
    title: 'Post Title 03',
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    url: '/knowledge-bank/detail/read//detail'
  },
  {
    title: 'Post Title 04',
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    url: '/knowledge-bank/detail/read//detail'
  }
];

function MobileReadHomeScreen() {
  const { t } = useTranslation(['knowledge-bank', 'common']);
  const history = useHistory();

  const onBack = () => {
    history.push('/knowledge-bank/detail')
  }

  const onReadMore = (url) => {
    history.push(url)
  }

  const VideoItem = ({item}) => {
    return (
      <Col xs={24}>
        <Box style={styles.box}>
          <Box paddingY={20} paddingX={15}>
            <Title level={4} style={styles.itemTitle}>
              {item.title}
            </Title>
            <Paragraph style={styles.itemDescription}>
              {item.description}
            </Paragraph>
            <Button
              type="link"
              onClick={() => onReadMore(item.url)}
              style={{ padding: 0, height: "auto" }}
            >
              <p style={styles.rowButton}>
                {t('knowledge-bank:readMore')} <ArrowRightOutlined style={{ marginLeft: 10}}/>
              </p>
            </Button>
          </Box>
        </Box>
      </Col>
    )
  }

  return (
    <>
      <HeaderBack
        onBack={onBack}
        text={t('knowledge-bank:returnCovid')}
        title={t('knowledge-bank:reads.title')}
        subtitle={t('knowledge-bank:reads.subtitle')}
      />
      <Divider />
      <Box marginTop={26} marginBottom={26}>
        <Form.Item
          style={{ width: '100%', padding: '3%' }}
          formItemLayout={formItemLayout}
        >
          <Search placeholder={t('knowledge-bank:reads.search')} />
        </Form.Item>
      </Box>
      <Row>
        {data.map((item) => <VideoItem item={item} />)}
      </Row>
    </>
  );
}

const styles = {
  box: {
    background: "#FFFFFF", 
    border: "1px solid #D9D9D9", 
    boxSizing: "border-box", 
    borderRadius: "4px",
    marginBottom: 25
  },
  itemTitle: {
    fontWeight: "500", 
    fontSize: "16px", 
    lineHeight: "24px", 
    color: "#262626",
    marginBottom: 8
  },
  itemDescription: {
    fontWeight: "300", 
    fontSize: "14px", 
    lineHeight: "22px", 
    color: "#8C8C8C"
  },
  rowButton: {
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export default MobileReadHomeScreen;
